var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section-card",
    {
      attrs: {
        "card-title": _vm.title,
        "card-icon": _vm.icon,
        "smaller-title": ""
      }
    },
    [
      _c(
        "div",
        { staticClass: "stack" },
        [
          _c("PeriodeMetOpdrachtenVolumes", {
            attrs: { opdrachtVolumes: _vm.periodeMetOpdrachten.volumes }
          }),
          _vm._v(" "),
          _vm._l(_vm.periodeMetOpdrachten.opdrachten, function(
            opdracht,
            index
          ) {
            return _c(
              "ehr-card",
              { key: "opdracht-card-" + index, staticClass: "list-item" },
              [_c("opdracht-card-content", { attrs: { opdracht: opdracht } })],
              1
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }